<template>
    <div>
        <el-table :data="list" style="width: 100%">
            <el-table-column label="头像">
                <template slot-scope="{ row }">
                    <el-avatar v-if="row.avatar" :size="50" :src="row.avatar | filterUrl"></el-avatar>
                    <el-avatar v-else :size="50" :src="require('@/assets/imgs/analysis/avatar.png')"></el-avatar>
                </template>
            </el-table-column>
            <el-table-column prop="nickname" label="姓名">
            </el-table-column>
            <el-table-column prop="username" label="昵称"> </el-table-column>
        </el-table>
        <el-pagination background prev-text="上一页" next-text="下一页" layout="total, prev, pager, next, jumper" :total="page.total"
            :current-page="page.page"
            :page-size="page.limit"
            :pager-count="page.pagerCount"
            @current-change="handPageChange"
            style="margin-top:15px"
        ></el-pagination>
    </div>
</template>
<script>
import { getUserList } from '@/api/shenbao/shenbao-user'
export default {
    data() {
        return {
            list: [],
            page: {
                page: 1,
                limit: 8,
                total: 0
            }
        }
    },
    methods: {
        getList() {
            const { page, limit } = this.page
            let params = {
                shenbaoId:this.shenbaoId
            }
            getUserList(this.shenbaoId, page, limit,params).then(res => {
                const { list , totalCount } = res
                this.list = list
                this.$set(this.page,'total', totalCount)
            })
        },
        handPageChange(page) {
            this.$set(this.page, "page", page);
            this.getList()
        },
    },
    props: {
        shenbaoId: {
            type: Number,
            default: null
        }
    },
    watch: {
        shenbaoId: {
            immediate: true,
            handler: function (newVal) {
                if (newVal) this.getList()
            }
        },
    },
}
</script>
